import { EventEmitter, Injectable } from '@angular/core';
import { SideMenu } from '@common/sidebar/side-menu.model';
import { MenuIcons } from '@models/menu-icons.model';
import { isMenuLinkAllowed } from '@constant/assistant-access-modules';
import { ActingAsService } from '@services/acting-as.service';
import { ApiService } from '@services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarMenuService {
  public SideMenuItems: any = { active: [], inactive: [] };
  public SideMenuItemsEmitter: EventEmitter<any> = new EventEmitter();
  menuIcons = Object.values(MenuIcons)
    ?.map((icons: any) => icons)
    ?.map((icons: any) => Object.values(icons));

  constructor(
    private api: ApiService,
    private actingAs: ActingAsService
  ) {}

  /** Reset in-memory menu so the next user does not see the previous session's sidebar. */
  clearMenuCache(): void {
    this.SideMenuItems = { active: [], inactive: [] };
    this.SideMenuItemsEmitter.next(this.SideMenuItems);
  }

  async getSidebarMenuItemsList() {
    let response: any = await this.api
      .get(`/get-customize-user-menu/${this.api.getUserId()}?is_user=true&office_id=${this.api.getOfficeId()}&role_id=null`)
      .toPromise()
      .catch(() => {
        this.SideMenuItems = this.scopeToActingAgent({ active: SideMenu || [], inactive: [] });
        this.SideMenuItemsEmitter.next(this.SideMenuItems);
      });
    const { status, data } = response || { status: false, data: null };
    if (status) {
      data.active.forEach(item => {
        if (item?.slug == 'calender') {
          item.title = 'Calendar';
        }
        if (item?.slug == 'settings') {
          item.link = '/setting/setup/visibility';
        }
      });
      this.SideMenuItems = this.scopeToActingAgent(data || { active: SideMenu || [], inactive: [] });
      this.SideMenuItemsEmitter.next(this.SideMenuItems);
    } else {
      this.SideMenuItems = this.scopeToActingAgent({ active: SideMenu || [], inactive: [] });
      this.SideMenuItemsEmitter.next(this.SideMenuItems);
    }
  }

  /** While a Sales Assistant acts as an agent, drop menu entries for modules the agent didn't grant. */
  private scopeToActingAgent(menu: any): any {
    const allowedModules = this.actingAs.getAllowedModules();
    if (!allowedModules) {
      return menu;
    }
    const keep = (item: any) => isMenuLinkAllowed(item?.link, allowedModules);
    return { ...menu, active: (menu?.active || []).filter(keep), inactive: (menu?.inactive || []).filter(keep) };
  }

  GetImageIconsPath(path: string = '') {
    try {
      let iconsList: any[] = this.menuIcons?.reduce((acc, curr) => {
        const items = curr.map(item => item);
        return acc.concat(items);
      }, []);
      return iconsList?.find(
        (icon: string) => `${path?.split('.')?.[0]?.split('/')?.at(-1)}.svg` === `${icon?.split('.')?.[0]?.split('/')?.at(-1)}.svg`
      );
    } catch (error) {
      return '';
    }
  }
}
